import GoldBenefits1 from "../assets/GoldBenefits1.svg";
import GoldBenefits2 from "../assets/GoldBenefits2.svg";
import GoldBenefits3 from "../assets/GoldBenefits3.svg";
import GoldBenefits4 from "../assets/GoldBenefits4.svg";

export default function GoldBenefits() {
    return (
        <div>
            <div className="flex flex-wrap justify-between space-y-10 md:space-y-0 z-20 mt-14">
                <div className="w-full sm:w-1/2 lg:w-1/4 px-10 lg:px-4 ">
                    <img src={GoldBenefits1} />
                    <div className="gold-line h-1.5 mt-5 w-10"></div>
                    <p className="font-black text-2xl mt-2">
                        Free For Full Family
                    </p>
                    <p className="text-lg">
                        Free consultations for upto{" "}
                        <span className="font-black">6 family members</span>
                    </p>
                </div>
                <div className="w-full sm:w-1/2 lg:w-1/4 px-10 lg:px-4 ">
                    <img src={GoldBenefits2} />
                    <div className="gold-line h-1.5 mt-5 w-10"></div>
                    <p className="font-black text-2xl mt-2">
                        Video Consultations
                    </p>
                    <p className="text-lg">
                        Video Consults with all Doctors,{" "}
                        <span className="font-black">24x7</span>
                    </p>
                </div>
                <div className="w-full sm:w-1/2 lg:w-1/4 px-10 lg:px-4 ">
                    <img src={GoldBenefits3} />
                    <div className="gold-line h-1.5 mt-5 w-10"></div>
                    <p className="font-black text-2xl mt-2">
                        Unlimited Free Consultations
                    </p>
                    <p className="text-lg">
                        Get unlimited free consultations with all{" "}
                        <span className="font-black">Doctors 24x7</span>
                    </p>
                </div>
                <div className="w-full sm:w-1/2 lg:w-1/4 px-10 lg:px-4 ">
                    <img src={GoldBenefits4} />
                    <div className="gold-line h-1.5 mt-5 w-10"></div>
                    <p className="font-black text-2xl mt-2">
                        Free For All Health Problems
                    </p>
                    <p className="text-lg">
                        Consult with any doctor from{" "}
                        <span className="font-black">18 departments{" "}</span>
                        at any time
                    </p>
                </div>
            </div>
        </div>
    );
}
